import { TrackingEvent, TrackingEvents } from '@lib/iab/iab-vast-model';

import isNonEmptyString from './is-non-empty-string';
import createTimeOffset from '../factory/time-offset';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    errorHandler: {
        tryRecover: (error: Error) => void;
    };
}

const mapTrackingEvents = (
    $trackingEvents: UnmarshalerNode,
    trackingEvents: TrackingEvents,
    options: ParseOptions
): void => {
    if ($trackingEvents == null || !Array.isArray($trackingEvents.tracking)) {
        return;
    }
    for (const $tracking of $trackingEvents.tracking as UnmarshalerNode[]) {
        if (!isNonEmptyString($tracking._value)) {
            continue;
        }
        const conf = new TrackingEvent();
        conf.uri = $tracking._value as string;
        // VAST 3.0: 'offset' attribute is available for 'progress' events only.
        // VAST 4.0: 'offset' attribute is available when <Linear> is the parent.
        if (isNonEmptyString($tracking.offset)) {
            try {
                conf.offset = createTimeOffset(
                    $tracking.offset as string,
                    options,
                    new Error()
                );
            } catch (error) {
                options.errorHandler.tryRecover(error as Error);
            }
        }
        trackingEvents.add($tracking.event as string, conf);
    }
};

export default mapTrackingEvents;
